var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 88,
    viewBox: "0 0 80 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1.75436e-05 30.1139V57.8454C-0.00416577 60.7046 0.739864 63.5143 2.15712 65.9914C3.57437 68.4686 5.61477 70.5256 8.07267 71.9552L31.9273 85.8209C34.3817 87.2485 37.1659 88 40 88C42.8341 88 45.6183 87.2485 48.0727 85.8209L71.9273 71.9552C74.3852 70.5256 76.4256 68.4686 77.8429 65.9914C79.2601 63.5143 80.0042 60.7046 80 57.8454V30.1139C79.9971 27.2617 79.2497 24.4603 77.8328 21.9909C76.4159 19.5216 74.3793 17.471 71.9273 16.0448L48.0727 2.17907C45.6183 0.751537 42.8341 0 40 0C37.1659 0 34.3817 0.751537 31.9273 2.17907L8.07267 16.2481C5.65006 17.6568 3.63231 19.6755 2.21715 22.1062C0.802002 24.5368 0.0379999 27.2962 1.75436e-05 30.1139Z",
    fill: "#FE6E5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2448 34.21L45.5035 43.9513L55.2439 53.7891L55.2524 53.797C56.2492 54.7171 56.2492 56.2415 55.2524 57.1616L55.2448 57.1686L53.1686 59.2448L53.1616 59.2524C52.2415 60.2492 50.7171 60.2492 49.797 59.2524L49.79 59.2448L40.0487 49.5035L30.2109 59.2439L30.203 59.2524C29.2829 60.2492 27.7585 60.2492 26.8384 59.2524L26.8314 59.2448L24.7552 57.1686L24.7476 57.1616C23.7508 56.2415 23.7508 54.7171 24.7476 53.797L24.7561 53.7891L34.4965 43.9513L24.7552 34.21L24.7476 34.203C23.7508 33.2829 23.7508 31.7585 24.7476 30.8384L24.7552 30.8314L26.8314 28.7552L26.8384 28.7476C27.7585 27.7508 29.2829 27.7508 30.203 28.7476L30.2109 28.7561L40.0487 38.4965L49.79 28.7552L49.797 28.7476C50.7171 27.7508 52.2415 27.7508 53.1616 28.7476L53.1686 28.7552L55.2448 30.8314L55.2524 30.8384C56.2492 31.7585 56.2492 33.2829 55.2524 34.203L55.2448 34.21Z",
    fill: "#FE6E5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon_error.1e9b63238ecfcbea53f647b47b744c3c.svg";
export { ForwardRef as ReactComponent };